import { asyncComponent } from 'react-async-component';
import FroalaPreloader from './FroalaPreloader';
import './style.scss';

export default asyncComponent({
  resolve: () => import(/* webpackChunkName: "froala" */ './RichEditor'),
  LoadingComponent: FroalaPreloader
});
